// For base implementation, see:
// https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest

/** Return a hexadecimal digest of a supplied string */
export const createDigestClient = async (
  message: string,
  algorithm: AlgorithmIdentifier = 'sha-256',
): Promise<string> => {
  const encoded = new TextEncoder().encode(message);
  const hashBuffer = await window.crypto.subtle.digest(algorithm, encoded);
  const arrayBuffer = Array.from(new Uint8Array(hashBuffer));
  const hashHex = arrayBuffer
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');

  return hashHex;
};
